export function generateInitials(input: string, maxLength: number = 2): string {
  const words: string[] = input.split(" ").filter((word) => word.length > 0);
  const initials: string[] = words
    .map((word) => word[0]?.toUpperCase() || "")
    .slice(0, maxLength);
  return initials.join("");
}
